import ProductTableAEB from "../../components/table/ProductTableAEB";

export default function ProductControl() {
	return (
		<section className="w-full h-full p-8">
			<ProductTableAEB />
		</section>
	);
}
